import { ServerApi } from 'modules/api/server-api';

export const candidateStartSuperSearch = (api: ServerApi) => async () => {
  return api.post('/v3/candidate/search-session/start');
};
